import type { IOption } from '../../../../types/option';

interface IMarkAsOption extends IOption {
    color: string;
}

interface IOnExportProps<TExportData> {
    markAs?: IMarkAsOption;
    rows: TExportData[];
}

export type TState<
    TExportData extends { [key: string]: unknown } = { [key: string]: unknown }
> = {
    excludeOptions: IOption[];
    markAsOptions: IMarkAsOption[];
    filterData: (
        data: TExportData[],
        selectedOptions: string[]
    ) => Array<Partial<TExportData>>;
    onExport: (props: IOnExportProps<TExportData>) => void;
};

export const state: TState = {
    excludeOptions: [],
    markAsOptions: [],
    filterData: (data) => data,
    onExport: () => {},
};
